<template>
  <div class="flex w-full overflow-hidden">

    <user-avatar :user="user"/>

    <div class="flex border-brand-dark-gray justify-between ml-4 w-full overflow-hidden">
      <div class="flex space-x-2 overflow-hidden w-full my-auto">
        <div class="text-white font-medium text-lg my-auto truncate">
          {{user.name }}
        </div>
        <div class="flex">
          <user-verification-check :user="user"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

import {computed, PropType, provide, ref} from "vue";
import {FriendUserInterface} from "@/interfaces/FriendUserInterface";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {useIonRouter} from "@ionic/vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";
import UserAvatar from "@/components/UserAvatar.vue";


const props = defineProps({
  user: {
    type: Object as PropType<UserBasicInformationInterface | ChatParticipantInterface>,
    required: true
  }
})


</script>
